import { useState } from 'react';

import { ButtonSpinnerDarkIcon } from '@svgs';

export const DeleteSite = ({ deleteMutations, siteData }) => {
  // delete confirmation
  const [showConfirmation, setShowConfirmation] = useState(false);

  // shared isPending
  const isPending =
    deleteMutations.site.isPending || deleteMutations.location.isPending;

  const onSiteDelete = async () => {
    // deleting just the site
    deleteMutations.site.mutateAsync();
  };

  const onSiteLocationDelete = async () => {
    // deleting the site and location together
    deleteMutations.location.mutateAsync();
    deleteMutations.site.mutateAsync();
  };

  return (
    <div className="sb-message sb-flex sb-message-delete">
      <div className="sb-flex sb-message-delete-inner">
        <span className="sb-message-icon"></span>
        <div className="sb-message-content">
          <p className="sb-message-title">Disable this website</p>
          <p className="sb-message-msg">
            This website will be disabled, but can be re-activated by searching.
            {siteData.location_ids.length == 1 && (
              <span>
                <br />
                Locations are permanently deleted
              </span>
            )}
          </p>
        </div>
      </div>
      {(!showConfirmation || isPending) && (
        <button
          type="button"
          className="sb-btn sb-btn-delete"
          onClick={() => setShowConfirmation(true)}
        >
          {isPending ? `Disabling...` : 'Disable'}
          {isPending && <ButtonSpinnerDarkIcon />}
        </button>
      )}
      {showConfirmation && !isPending && (
        <div>
          {siteData.location_ids.length == 1 && (
            <>
              <button
                type="button"
                className="sb-btn sb-btn-delete-confirm"
                onClick={onSiteLocationDelete}
              >
                Disable website and delete associated Location
              </button>
              <button
                type="button"
                className="sb-btn sb-btn-delete-confirm"
                onClick={onSiteDelete}
              >
                Disable only website
              </button>
            </>
          )}
          {siteData.location_ids.length != 1 && (
            <button
              type="button"
              className="sb-btn sb-btn-delete-confirm"
              onClick={onSiteDelete}
            >
              Disable website
            </button>
          )}
          <button
            type="button"
            className="sb-btn sb-btn-delete"
            onClick={() => setShowConfirmation(false)}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};
